module.exports = __webpack_public_path__ + "static/media/news4-1.3ed298d1.jpg";